import { render, staticRenderFns } from "./TeacherDetailDialog.vue?vue&type=template&id=1c02545c&scoped=true"
import script from "./TeacherDetailDialog.vue?vue&type=script&lang=js"
export * from "./TeacherDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TeacherDetailDialog.vue?vue&type=style&index=0&id=1c02545c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c02545c",
  null
  
)

export default component.exports